(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/views/statbase.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/views/statbase.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};

  svs.statistics.views.StatBase = Backbone.View.extend({
    statViewLoader: null,

    showLoader: function() {
      if (!this.statViewLoader) {
        if (!this.$el || !this.$el.parent().length) {
          return;
        }
        if (
          this.$el.parent().find('.statistics-elements-loader').length === 0
        ) {
          var loaderElement = $(
            '<div class="statistics-elements-loader loader-container"></div>'
          );
          this.$el.parent().append(loaderElement);
          $('.statistics-elements-loader').css({
            height: $(window).height() + 'px',
            position: 'absolute'
          });
          this.statViewLoader = new svs.components.Loader(loaderElement);
        }
      }
      this.statViewLoader.show();
    },
    hideLoader: function() {
      if (this.statViewLoader) {
        this.statViewLoader.hide();
      }
    },
    onDestroy: function() {
      this.statViewLoader.hide();
      delete this.statViewLoader;
    }
  });
})(Backbone, _, svs);

 })(window);